module.exports = __webpack_public_path__ + "fonts/nanumbarungothicbold-webfont.84ea98e4.woff";